import React from "react";

import { useAppContext } from "@app/helpers/hooks";

import { AccountItemLayout } from "../account-item-layout";

export const AccountLink: React.FC = () => {
  const { translator, urlBuilder } = useAppContext();

  return (
    <AccountItemLayout
      className="footer-account-button"
      link={urlBuilder.accountTrips()}
      label={translator.t("!footer.account.menu")}
    />
  );
};
